import type { ChartType, Plugin } from 'chart.js'

export type DrawCellGuidesOpts = {
  color: string
  disabled?: boolean
}

/**
 * Chart.js plugin for a chart in a table cell: a 1px baseline at the bottom
 * of the chart area.
 */
export const drawCellGuides: Plugin<ChartType, DrawCellGuidesOpts> = {
  id: 'drawCellGuides',

  // Behind the datasets, so the bars stand on the baseline.
  beforeDatasetsDraw(chart, _args, opts) {
    if (!opts || opts.disabled) return

    const { ctx, chartArea } = chart

    ctx.save()
    ctx.fillStyle = opts.color
    ctx.fillRect(
      chartArea.left,
      chartArea.bottom - 1,
      chartArea.right - chartArea.left,
      1
    )
    ctx.restore()
  }
}
